import { call, put, takeLatest } from "redux-saga/effects";
import { CommonAPI } from "../../../api/commonAPI";
import {
  GET_PERFORMANCE_SUMMARY_REQUEST,
  GET_PERFORMANCE_SUMMARY_SUCCESS,
  GET_PERFORMANCE_SUMMARY_ERROR,
} from "../../actions";

function* workerPerformanceSummary(action: {
  type: string;
  payload: any;
  meta?: { period?: string };
}): Generator<any> {
  try {
    const response: any = yield call(
      CommonAPI.getPerformanceSummary,
      action.payload
    );
    // Filter only all_time_income and unique_reservations_* keys
    const fullData = response?.data?.[0] || {};    
    // Determine period key
    let period =
      action?.meta?.period ||
      (action.payload && action.payload.param) ||
      "summary";
    yield put({
      type: GET_PERFORMANCE_SUMMARY_SUCCESS,
      payload: { [period]: fullData },
    });
  } catch (error) {
    yield put({ type: GET_PERFORMANCE_SUMMARY_ERROR, payload: error });
  }
}

export function* watcherPerformanceSummary() {
  yield takeLatest(GET_PERFORMANCE_SUMMARY_REQUEST, workerPerformanceSummary);
}
